// extracted by mini-css-extract-plugin
export default {"appDocSectionWrapper":"ApplicationDetailsDocSection_appDocSectionWrapper__uRL90"};